export const countries = {
  default: '国を選択',
  japan: '日本',
  afghanistan: 'アフガニスタン',
  albania: 'アルバニア',
  algeria: 'アルジェリア',
  andorra: 'アンドラ',
  angola: 'アンゴラ',
  antiguaAndBarbuda: 'アンティグア・バーブーダ',
  argentine: 'アルゼンチン',
  armenia: 'アルメニア',
  australia: 'オーストラリア',
  austria: 'オーストリア',
  azerbaijan: 'アゼルバイジャン',
  bahamas: 'バハマ',
  bahrain: 'バーレーン',
  bangladesh: 'バングラデシュ',
  barbados: 'バルバドス',
  belarus: 'ベラルーシ',
  belgium: 'ベルギー',
  belize: 'ベリーズ',
  benin: 'ベナン',
  bhutan: 'ブータン',
  bolivia: 'ボリビア',
  bosniaAndHerzegovina: 'ボスニア・ヘルツェゴビナ',
  botswana: 'ボツワナ',
  brazil: 'ブラジル',
  bruneiDarussalam: 'ブルネイ',
  bulgaria: 'ブルガリア',
  burkinaFaso: 'ブルキナファソ',
  burundi: 'ブルンジ',
  caboVerde: 'カーボベルデ',
  cambodia: 'カンボジア',
  cameroon: 'カメルーン',
  canada: 'カナダ',
  centralAfricanRepublic: '中央アフリカ共和国',
  chad: 'チャド',
  chile: 'チリ',
  china: '中国',
  colombia: 'コロンビア',
  comoros: 'コモロ',
  congo: 'コンゴ',
  costaRica: 'コスタリカ',
  coteDivoire: 'コートジボアール',
  croatia: 'クロアチア',
  cuba: 'キューバ',
  cyprus: 'キプロス',
  czechRepublic: 'チェコ',
  democraticPeopleRepublicOfKorea: '朝鮮民主主義人民共和国',
  democraticRepublicOfTheCongo: 'コンゴ民主共和国',
  denmark: 'デンマーク',
  djibouti: 'ジブチ',
  dominica: 'ドミニカ',
  dominicanRepublic: 'ドミニカ共和国',
  ecuador: 'エクアドル',
  egypt: 'エジプト',
  elSalvador: 'エルサルバドル',
  equatorialGuinea: '赤道ギニア',
  eritrea: 'エリトリア',
  estonia: 'エストニア',
  eswatini: 'エスワティニ',
  ethiopia: 'エチオピア',
  fiji: 'フィジー',
  finland: 'フィンランド',
  france: 'フランス',
  gabon: 'ガボン',
  gambia: 'ガンビア',
  georgia: 'ジョージア',
  germany: 'ドイツ',
  ghana: 'ガーナ',
  greece: 'ギリシャ',
  grenada: 'グレナダ',
  guatemala: 'グアテマラ',
  guinea: 'ギニア',
  guineaBissau: 'ギニアビサウ',
  guyana: 'ガイアナ',
  haiti: 'ハイチ',
  honduras: 'ホンジュラス',
  hungary: 'ハンガリー',
  iceland: 'アイスランド',
  india: 'インド',
  indonesia: 'インドネシア',
  iran: 'イラン',
  iraq: 'イラク',
  ireland: 'アイルランド',
  israel: 'イスラエル',
  italy: 'イタリア',
  jamaica: 'ジャマイカ',
  jordan: 'ヨルダン',
  kazakhstan: 'カザフスタン',
  kenya: 'ケニア',
  kiribati: 'キリバス',
  kuwait: 'クウェート',
  kyrgyzstan: 'キルギスタン',
  laoPeopleDemocraticRepublic: 'ラオス人民民主共和国',
  latvia: 'ラトビア',
  lebanon: 'レバノン',
  lesotho: 'レソト',
  liberia: 'リベリア',
  libya: 'リビア',
  liechtenstein: 'リヒテンシュタイン',
  lithuania: 'リトアニア',
  luxembourg: 'ルクセンブルク',
  madagascar: 'マダガスカル',
  malawi: 'マラウィ',
  malaysia: 'マレーシア',
  maldives: 'モルディブ',
  mali: 'マリ',
  malta: 'マルタ',
  marshallIslands: 'マーシャル諸島',
  mauritania: 'モーリタニア',
  mauritius: 'モーリシャス',
  mexico: 'メキシコ',
  micronesia: 'ミクロネシア連邦',
  monaco: 'モナコ',
  mongolia: 'モンゴル',
  montenegro: 'モンテネグロ',
  morocco: 'モロッコ',
  mozambique: 'モザンビーク',
  myanmar: 'ミャンマー',
  namibia: 'ナミビア',
  nauru: 'ナウル',
  nepal: 'ネパール',
  netherlands: 'オランダ',
  newZealand: 'ニュージーランド',
  nicaragua: 'ニカラグア',
  niger: 'ニジェール',
  nigeria: 'ナイジェリア',
  northMacedonia: '北マケドニア',
  norway: 'ノルウェー',
  oman: 'オマーン',
  pakistan: 'パキスタン',
  palau: 'パラオ',
  panama: 'パナマ',
  papuaNewGuinea: 'パブア・ニューギニア',
  paraguay: 'パラグアイ',
  peru: 'ペルー',
  philippines: 'フィリピン',
  poland: 'ポーランド',
  portugal: 'ポルトガル',
  qatar: 'カタール',
  korea: '韓国',
  moldova: 'モルドバ',
  romania: 'ルーマニア',
  russian: 'ロシア',
  rwanda: 'ルワンダ',
  saintKittsAndNevis: 'セントクリストファー・ネイビス',
  saintLucia: 'セントルシア',
  saintVincent: 'セントビンセントおよびグレナディーン諸島',
  samoa: 'サモア',
  sanMarino: 'サンマリノ',
  saoTomeAndPrincipe: 'サントメ・プリンシペ',
  saudiArabia: 'サウジアラビア',
  senegal: 'セネガル',
  serbia: 'セルビア',
  seychelles: 'セイシェル',
  sierraLeone: 'シエラレオネ',
  singapore: 'シンガポール',
  slovakia: 'スロバキア',
  slovenia: 'スロベニア',
  solomonIslands: 'ソロモン諸島',
  somalia: 'ソマリア',
  southAfrica: '南アフリカ',
  southSudan: '南スーダン',
  spain: 'スペイン',
  sriLanka: 'スリランカ',
  sudan: 'スーダン',
  suriname: 'スリナメ',
  sweden: 'スウェーデン',
  switzerland: 'スイス',
  syria: 'シリア',
  tajikistan: 'タジキスタン',
  thailand: 'タイ',
  timorLeste: '東ティモール',
  togo: 'トーゴ',
  tonga: 'トンガ',
  trinidadAndTobago: 'トリニダード・トバゴ',
  tunisia: 'チュニジア',
  turkey: 'トルコ',
  turkmenistan: 'トルクメニスタン',
  tuvalu: 'ツバル',
  uganda: 'ウガンダ',
  ukraine: 'ウクライナ',
  unitedArabEmirates: 'アラブ首長国連邦',
  unitedkingdom: 'イギリス',
  UnitedRepublicOfTanzania: 'タンザニア',
  UnitedStatesOfAmerica: 'アメリカ',
  uruguay: 'ウルグアイ',
  uzbekistan: 'ウズベキスタン',
  vanuatu: 'バヌアツ',
  venezuela: 'ベネズエラ',
  vietNam: 'ベトナム',
  yemen: 'イエメン',
  zambia: 'ザンビア',
  zimbabwe: 'ジンバブエ',
}
